// TODO: Dedupe.
export const COLLAPSED_COMPACT_BORDER_RADIUS = 8;

// TODO: Dedupe.
export const COLLAPSED_SQUARED_BORDER_RADIUS_BY_SIZE = {
  small: 8,
  medium: 10,
  large: 12,
};

// TODO: Dedupe.
export const COLLAPSED_DIMENSIONS_BY_SIZE = {
  small: { width: 144, height: 32 },
  medium: { width: 148, height: 36 },
  large: { width: 152, height: 40 },
  huge: { width: 232, height: 64 },
};
